import React, { useEffect, useState } from "react";
import styles from "./Compund.module.css";
import InvestmentDetails from "./InvestmentDetails/InvestmentDetails";
import DetailGraph from "./DetailedBreakdown/DetailedBreakDown";
import KnowledgeHub from "./KnowledgeHub/KnowledgeHub";
import { useNavigate } from "react-router-dom";

const CompoundInterest = () => {
  const [investmentAmount, setInvestmentAmount] = useState(100);
  const [expectedReturns, setExpectedReturns] = useState(0);
  const [investmentYears, setInvestmentYears] = useState(1);
  const [activeTab, setActiveTab] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.container}>
      <div
        className={styles.breadCrumb}
        onClick={() => navigate("/calculator")}
      >
        <span className="material-symbols-rounded">chevron_left</span>
        <h1>Compound Interest Calculator</h1>
      </div>

      <InvestmentDetails
        investmentAmount={investmentAmount}
        expectedReturns={expectedReturns}
        investmentYears={investmentYears}
        setInvestmentAmount={setInvestmentAmount}
        setExpectedReturns={setExpectedReturns}
        setInvestmentYears={setInvestmentYears}
        setActiveTab={setActiveTab}
        activeTab={activeTab}
      />

      <DetailGraph
        activeTab={activeTab}
        investmentAmount={investmentAmount}
        expectedReturns={expectedReturns}
        investmentYears={investmentYears}
      />
      {/* <KnowledgeHub /> */}
    </div>
  );
};

export default CompoundInterest;
